import { Modal } from 'antd'
import { ApiError } from '../error/api-error'
import { GeekExceptionType } from '../exceptions/exception-types'
import { openPremiumPage } from './promocode'
import { NavigateFunction } from 'react-router-dom'
import NotificationsUtils from '../../components/utils/NotificationsUtils'

export const handleHttpError = (error: ApiError, navigate: NavigateFunction): void => {
    if (error?.type === GeekExceptionType.CARD_LIMIT) {
        openPremiumPage(navigate)
    } else if (error?.type === GeekExceptionType.MAX_NOT_PREMIUM_COMMUNITY_AMOUNT)
        NotificationsUtils.openErrorNotification('Без премиум аккаунта доступно только 5 сообществ')
    else {
        Modal.error({
            title: 'Ошибка!',
            content: error.message
        })
    }
}